import React, { useEffect, useState } from "react";
import AlertField from "../Components/AlertField";
import BlogCard from "../Components/BlogCard";
import Paginate from "../Components/Paginate";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";

const MyBlogs = () => {
  const [alert, setAlert] = useState(null);
  const [values, setValues] = useState({});
  const [pageCount, setpageCount] = useState(0);
  const [count, setCount] = useState(0);
  const [endValue, setEndValue] = useState(0);
  const [startValue, setStartValue] = useState(1);
  const limit = 5;
  const axiosPrivate = useAxiosPrivate();
  
  useEffect(() => {
    let timeoutId = setTimeout(() => {
      setAlert(null);
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, []);
  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  useEffect(() => {
    const url = `blog/doctor?limit=${limit}`;
    fetchData(url);
  }, []);

  const fetchData = async (url) => {
    try {
      const response = await axiosPrivate.get(url);
      //sets the list of data got from api
      setValues(response?.data.results);

      //gets the total record and divides by 5 to set pagination number
      setpageCount(Math.ceil(response.data.count / 5));
      //sets the total number of record to display in bottom message
      setCount(response?.data.count);
      //sets the end value as length of records got
      setEndValue(response?.data.results.length);
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else {
        showAlert("Load Failed", "warning");
      }
    }
  };

  const handlePageClick = async (data) => {
    let currentPage = data.selected * limit;

    const url = `blog/?limit=${limit}&offset=${currentPage}`;

    //calls the api with limit and currentpage as offset and get response data
    const response = await fetchData(url);

    //sets start value
    setStartValue(data.selected * limit + 1);

    if (response?.data.results.length === 0) {
      setStartValue(0);
      setEndValue(0);
    }
  };

  const onDelete = async (id) => {
    try {
      await axiosPrivate.delete(`blog/${id}/`);
      fetchData(`blog/doctor?limit=${limit}`);
      showAlert("Blog Deleted.", "success");
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response.", "warning");
      } else {
        showAlert("Delete Failed.", "warning");
      }
    }
    
    //closes the modal form
    document.getElementById(`confirmationModal${id}-close`).click();
  };

  return (
    <>
      <AlertField alert={alert} />
      <h2 className="text-center py-2 mb-4">My Blogs</h2>
      <div className="text-end me-3 mb-2">
        <a href="/post/blog" className="btn btn-primary me-5">
          Post Blog
        </a>
      </div>
      <div className="w-100 row row-cols-2 m-0 px-5 justify-content-between">
        {values?.length > 0 ? (
          values?.map((values, i) => (
            <div className="col" key={i}>
              <BlogCard values={values} i={i} onDelete={onDelete} />
            </div>
          ))
        ) : (
          <h2 className="text-center w-100 py-2 mb-4">
            You have not posted any blogs.
          </h2>
        )}
      </div>
      <div className="mx-5 px-5">
        <Paginate
          startValue={startValue}
          endValue={endValue}
          count={count}
          pageCount={pageCount}
          handlePageClick={handlePageClick}
        />
      </div>
    </>
  );
};

export default MyBlogs;
